import { useEffect, useState } from "react";
import { CalendarDays } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export default function ActiveEventPicker({ compact }) {
  const [events, setEvents] = useState([]);
  const [active, setActive] = useState("");
  useEffect(() => {
    api.get("/events").then((r) => setEvents(r.data)).catch(() => {});
    api.get("/workspace").then((r) => setActive(r.data.active_event_id || "")).catch(() => {});
  }, []);
  const change = async (v) => {
    try {
      await api.put("/workspace/active-event", { event_id: v || null });
      setActive(v);
      toast.success(v ? "New captures will be added to this event" : "No active event");
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <label className={`flex items-center gap-2 rounded-xl border border-slate-200 bg-white px-3 ${compact ? "h-11" : "h-12"}`}>
      <CalendarDays className="h-4 w-4 shrink-0 text-teal-700" />
      <span className="whitespace-nowrap text-xs font-semibold text-slate-500">Active event</span>
      <select data-testid="active-event-select" value={active} onChange={(e) => change(e.target.value)} className="min-w-0 flex-1 bg-transparent text-sm font-semibold outline-none">
        <option value="">None</option>
        {events.map((e) => <option key={e.id} value={e.id}>{e.name}</option>)}
      </select>
    </label>
  );
}
